
import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import Routes from './Routes';
import history from './history';
import HttpsRedirect from 'react-https-redirect';
import Authorization from "./components/authorization";
import AuthGate from "./components/authorization/AuthGate.jsx";

const App = () => {
  return (
    <HttpsRedirect>
      <AuthGate/>
      <Authorization/>
      <Router history={history}>
        <Routes />
      </Router>
    </HttpsRedirect>
  );
};

export default App;
